import React, { useEffect, useState } from "react";
import { Checkbox, Progress } from "antd";
import playerImg from "assets/playervideo.png";
import { useLocation } from "react-router-dom";
import { checkItem, formatVideoUrl } from "utils";
import "./style.scss";
import { UserOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { api } from "services/api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { IProgress } from "types";
import { AddTopicModal, Loading, ViemForumModal } from "components";
import { useForm } from "antd/lib/form/Form";

export const ModulePage: React.FC = () => {
	// @ts-ignore
	const { state }: { state: ICourse } = useLocation();
	const { id: userId } = useSelector((state: any) => state.app.user);
	const [value, setValue] = useState<string>("");
	const [moduleContent, setModuleContent] = useState<any[]>([]);
	const [forumTopics, setForumTopics] = useState<any[]>();
	const [topicId, setTopicId] = useState<string>("");
	const [topicsInfos, setTopicsInfos] = useState<any>();
	const [currentTopic, setCurrentTopic] = useState<any>();
	const [progress, setProgress] = useState<IProgress>();
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [forumClassId, setForumClassId] = useState<string>("");
	const [isOpenForum, setIsOpenForum] = useState<boolean>(false);
	const [form] = useForm();
	const [titles, setTitles] = useState({
		moduleTitle: "",
		lessonTitle: "",
		lessonDescription: "",
		index: 1,
		currentClassId: "",
	});

	const [pageType, setPageType] = useState<string>("class");

	const course = state.courseGeneralInfo;

	const handleSendMessage = () => {
		api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: value,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					api.get(`/topics/${topicId}/messages`).then((res) => {
						setTopicsInfos(res.data.data);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setValue("");
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		const loadCourse = async () => {
			setTitles(course.currentModule);
		};

		if (course) {
			loadCourse();
		}
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		const getForumTopics = async () => {
			setForumTopics(undefined);
			if (forumClassId) {
				await api
					.get(`/forums/${forumClassId}/topics`)
					.then((r) => {
						setForumTopics(r.data.data.topics);
					})
					.catch((err) => {
						setForumTopics([]);
						console.log(err);
					});
			}
		};

		getForumTopics();
	}, [forumClassId]);

	const loadProgress = async () => {
		if (userId) {
			await api
				.get(`/courses/${course.id}/users/${userId}/progress`)
				.then((r) => {
					setProgress(r.data.data);
				});
		}
	};

	useEffect(() => {
		loadProgress();
	}, [userId, course]);

	useEffect(() => {
		const getData = async () => {
			await api.get(`/classes/${titles.currentClassId}/content`).then((res) => {
				if (res.data.data.blockes) {
					setModuleContent(res.data.data.blockes);
				}
			});

			await api.get(`/classes/${titles.currentClassId}`).then((res) => {
				if (res.data.data.forum) {
					setForumClassId(res.data.data.forum.id);
				}
			});
		};

		if (titles.currentClassId) {
			getData();
		}
	}, [titles]);

	return (
		<div className="module">
			<AddTopicModal
				setIsOpen={setIsOpen}
				isOpen={isOpen}
				forumId={forumClassId}
				form={form}
				setForumTopics={setForumTopics}
			/>

			<ViemForumModal
				setIsOpen={setIsOpenForum}
				isOpen={isOpenForum}
				currentCourseData={course}
				isCourse={true}
			/>

			<div className="container-fluid module__container">
				<div className="row module__container__body">
					<div className="module__container__header mb-4">
						<div className="module__container__info__header">
							<img
								src={course.image ? course.image : playerImg}
								width="40%"
								alt=""
							/>
							<div className="module__container__info__header__content">
								<h1 className="module__container__info__header__content__title">
									{course.title}
								</h1>
								<span className="module__container__info__header__content__author">
									(Por {course.author})
								</span>
							</div>
						</div>
						<Progress
							percent={progress?.progress}
							strokeWidth={8}
							showInfo={false}
						/>
						<p className="percent">{progress?.progress}%</p>
					</div>
					<hr className="mb-4"/>
					<div className="col-lg-4 mt-3 mt-lg-0">
						<div className="module__container__info__module-courses">
							{course.modules &&
								course.modules?.map((module: any, index: number) => {
									return (
										<div
											key={index}
											className="module__container__info__module-courses__module"
										>
											<h1 className="module__container__info__module-courses__module__title">
												{index + 1}. {module.title}
											</h1>
											<p className="fw-medium text-light-emphasis">Aulas:</p>
											<div className="module__container__info__module-courses__module__available-classes">
												{module.classes.length !== 0 &&
													module.classes.map((lesson: any, i: number) => {
														return (
															<div
																key={i}
																className={`module__container__info__module-courses__module__available-classes__class ${
																	titles.currentClassId === lesson.id &&
																	titles.moduleTitle === module.title
																		? "--selected"
																		: ""
																}`}
																onClick={() => {
																	setForumTopics(undefined);
																	setTopicsInfos(undefined);
																	setTitles({
																		moduleTitle: module.title,
																		lessonTitle: lesson.title,
																		lessonDescription: lesson.description,
																		index: index + 1,
																		currentClassId: lesson.id,
																	});

																	const lessonContent = document.getElementById('lessonContent') as HTMLDivElement;
																	lessonContent.scrollIntoView({
																		behavior: 'smooth',
																	});
																}}
															>
																<p className="text-info-emphasis  ps-2" style={{ borderLeft: "#63b8cd 3px solid" }}>
																	{i + 1}. {lesson.title}
																</p>
																<Checkbox
																	defaultChecked={lesson.is_finished}
																	onClick={async (e: any) => {
																		if (e.currentTarget.checked) {
																			await api.get(
																				`/classes/${lesson.id}/users/${userId}/finish`
																			);
																		} else {
																			await api.get(
																				`/classes/${lesson.id}/users/${userId}/continue`
																			);
																		}
																		loadProgress();
																		setTitles({
																			moduleTitle: module.title,
																			lessonTitle: lesson.title,
																			lessonDescription: lesson.description,
																			index: index + 1,
																			currentClassId: lesson.id,
																		});
																	}}
																/>
															</div>
														);
													})}
												{module.classes.length === 0 && (
													<h6 style={{color: "rgb(147 147 147)"}}>Não há aulas disponíveis.</h6>
												)}
											</div>
										</div>
									);
								})}
						</div>
					</div>
					<div id="lessonContent" className="d-lg-none">
						{/* O conteúdo fica na próxima div. Esta div é utilizada para fazer o scroll da tela sem cortar o conteúdo da aula em telas menores*/}
					</div>
					<div className="col-lg-8 mt-5 mt-lg-0">
						<div className="module__container__lesson">
							<h1 className="module__container__lesson__lesson-title">
								{titles.lessonTitle}
							</h1>
							<p className="module__container__lesson__description">
								{titles.lessonDescription}
							</p>
							<div className="module__container__lesson__content">
								{moduleContent.map((item) => {
									if (item.type === "youtube") {
										return (
											<div>
												<iframe
													title="Video"
													width="500px"
													height="300px"
													src={formatVideoUrl(item.content, true)}
												></iframe>
											</div>
										);
									}
									if (item.type === "archive") {
										return (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													flexDirection: "column",
												}}
											>
												<p style={{ margin: 0, fontSize: "18px" }}>
													Arquivo em anexo:{" "}
												</p>
												<a
													href={item.content}
													target="_blank"
													rel="noreferrer"
													style={{ fontSize: "17px", margin: 0 }}
												>
													Abrir anexo
												</a>
											</div>
										);
									}
									if (item.type === "vimeo") {
										return (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
											>
												<iframe
													src={formatVideoUrl(item.content, false)}
													width="520px"
													height="300px"
													title="video"
												></iframe>
											</div>
										);
									}
									if (item.type === "image") {
										return (
											<img
												src={item.content}
												style={{ width: "520px", height: "auto" }}
												alt=""
											></img>
										);
									}
									if (item.type === "text") {
										return (
											<p className="module__container__lesson__content__text">
												<div
													style={{ paddingLeft: "20px", paddingRight: "20px" }}
													dangerouslySetInnerHTML={{
														__html: item.content,
													}}
												></div>
											</p>
										);
									}
									return <></>;
								})}
							</div>
							<div className="module__container__lesson__btns">
								<button onClick={() => window.history.back()}>
									Página do curso
								</button>
								<button onClick={() => setIsOpenForum(true)}>
									Fórum de dúvidas
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
